import { axiosInstance } from "@/helper/axios-instance";
import { useMutation } from "@tanstack/react-query";

type Args = {
  household?: string;
  type: string;
  detailCode: string | undefined;
  externalCode: string | undefined;
  fileName: string;
  contentType?: string;
};

export function usePrintLTIPTranchDetail() {
  return useMutation({
    mutationFn: async ({ household, type, detailCode, externalCode, fileName }: Args) => {
      const response = await axiosInstance({
        method: "GET",
        responseType: "arraybuffer",
        url:
          
          `Salesforce/PrintLTIPTranchDetail/${type}/${household}/${externalCode}?detailCode=${detailCode}`,
      });
      return { response, fileName };
    },
    onSuccess: (data) => {
      const { response, fileName } = data;

      const blob = new Blob([response.data], { type: "application/octetstream" });

      const url = window.URL || window.webkitURL;
      const link = url.createObjectURL(blob);
      const a = document.createElement("a");

      a.setAttribute("download", fileName);
      a.setAttribute("href", link);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  });
}
